import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery, useTheme, List,ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, Drawer, Box, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TableChartIcon from '@mui/icons-material/TableChart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BillingIcon from '@mui/icons-material/Receipt';
import PersonIcon from '@mui/icons-material/Person';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import logo from './TOSC_white.png';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import { Link, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'
import '../styles.css';
import { useState, useEffect } from 'react'
import Image from './tiny.jpg'

function Sidebar(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  
  // Use media query to check for screen size
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm')); 

  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

const bgnavbar = {
  borderRight: '0px',
  paddingRight: '0px',
}
const drawerWidth = 240;
const {logout} = useAuth();

const drawer = (
  <div>
    <Box sx={{padding: 1 }}>
      <a href="https://tosc.techkriti.org" target="_blank" rel="noreferrer"><img alt='' src={logo} className='logo'  /></a>
      </Box>
      <Divider />
    <List >
        {/* Dashboard */}
        <Link style={{ textDecoration: 'none', color: '#fff' }} to='dashboard'>
        <ListItemButton sx={{marginBottom: 0.5}} onClick={handleDrawerToggle}>
          <ListItemIcon>
            <DashboardIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>
        </Link>
        
        <Link style={{ textDecoration: 'none', color: '#fff' }} to='/pyq'>
        <ListItemButton onClick={handleDrawerToggle}>
          <ListItemIcon>
            <TableChartIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Sample Papers" />
        </ListItemButton>
        </Link>

        {/* Payment */}
        <Link to = "/payment" style={{ color: 'white', textDecoration: 'none' }}>
        <ListItemButton onClick={handleDrawerToggle}>
          <ListItemIcon>
            <BillingIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Payment" />
        </ListItemButton>
        </Link>

        {/* Profile */}
        {/* <Link to = "/update-profile" style={{ color: 'white', textDecoration: 'none' }}>
        <ListItemButton onClick={handleDrawerToggle}>
          <ListItemIcon>
            <PersonIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Update Profile" />
        </ListItemButton>
        </Link> */}
        
        
        {/* Sign Out */}
        
        <ListItemButton onClick={handleLogout}  >
          <ListItemIcon>
            <ExitToAppIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Sign Out" />
        </ListItemButton>
       
      </List>



    {/* <List style={bgnavbar}>
      <Link to="dashboard" style={{ textDecoration: 'none' }}>
      <ListItem >
        <ListItemButton className='buttonhover'>
          <ListItemText className='sidebarbutton' primary="Dashboard" />
        </ListItemButton>
      </ListItem>
      </Link>
      <Link to="pyq" className='active' style={{ textDecoration: 'none' }}>
        <ListItem >
          <ListItemButton className='buttonhover'>
            <ListItemText primary="Previous Year Papers" />
          </ListItemButton>
        </ListItem>
      </Link>

    </List> */}
    <Divider />
  </div>
);


const container = window !== undefined ? () => window().document.body : undefined;
//const [anchorEl, setAnchorEl] = React.useState(null);
//const open = Boolean(anchorEl);
const [error, setError] = useState('');
//const { currentUser, logout } = useAuth();

// const handleClick = (event) => {
//   setAnchorEl(event.currentTarget);
// };
// const handleClose = () => {
//   setAnchorEl(null);
// };
// const navigate = useNavigate();

async function handleLogout() {
  try {
    setError('');
    await logout();
    localStorage.removeItem("token");
    navigate('/login');
  } catch {
    setError('Failed to logout')
  }
}

  return (
    <>
          <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' }, position: 'absolute', marginLeft: 0 }}  >
          <MenuIcon />
      </IconButton>
      
    {isLargeScreen && (<Drawer component="nav" 
      sx={{
        width: 300,
        flexShrink: 0,
        
        '& .MuiDrawer-paper': {
          width: 300,
          height: '97vh',
          boxSizing: 'border-box',
          marginTop: '10px', marginLeft: '10px',
          paddingLeft: '5px',
          borderRadius: '10px',
          background: 'url(${Image})',
          backdropFilter: 'blur(10px)',
          border: '1px solid white',
          
          //backgroundColor: '#263238', // Darker background like the image
          color: '#fff', // White text
        },
      }}
      variant="permanent"
      anchor="left"
    >

      <Box sx={{padding: 1 }} >
      <a href="https://tosc.techkriti.org" target="_blank" rel="noreferrer"><img alt='' src={logo} className='logo'  /></a>
      </Box>
      <Divider />
      <List>
        {/* Dashboard */}
        <Link style={{ textDecoration: 'none', color: '#fff' }} to='dashboard'>
        <ListItemButton sx={{marginBottom: 0.5}}>
          <ListItemIcon>
            <DashboardIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>
        </Link>
        
        <Link style={{ textDecoration: 'none', color: '#fff' }} to='/pyq'>
        <ListItemButton>
          <ListItemIcon>
            <TableChartIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Sample Papers" />
        </ListItemButton>
        </Link>

        {/* Payment */}
        <Link to = "/payment" style={{ color: 'white', textDecoration: 'none' }}>
        <ListItemButton>
          <ListItemIcon>
            <BillingIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Payment" />
        </ListItemButton>
        </Link>

        {/* Profile */}
        {/* <Link to = "/update-profile" style={{ color: 'white', textDecoration: 'none' }}>
        <ListItemButton>
          <ListItemIcon>
            <PersonIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Update Profile" />
        </ListItemButton>
        </Link> */}
        
        
        {/* Sign Out */}
        
        <ListItemButton onClick={handleLogout} >
          <ListItemIcon>
            <ExitToAppIcon sx={{ color: '#fff' }} />
          </ListItemIcon>
          <ListItemText primary="Sign Out" />
        </ListItemButton>
        
      </List>
     
    </Drawer> )}
    <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          <Drawer
            PaperProps={{
              sx: {  marginTop: '10px', marginLeft: '10px', marginBottom: '100px',
                borderRadius: '10px',          background: 'url(${Image})',
                backdropFilter: 'blur(10px)',
                border: '1px solid white', }
            }}

            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              backdropFilter: "blur(8px)",
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, height : '97vh', color: '#fff'  },
            }}
          >
            {drawer}
          </Drawer>
          </Box>
    </>
  );

};

Sidebar.propTypes = {
  window: PropTypes.func,
};

export default Sidebar;
